import { cn } from "@/utils/cn"
import { Button } from "./button"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"
import { CalendarIcon } from "lucide-react"
import { Calendar } from "./calendar"
import { format } from "date-fns"
import { FIELD_ERROR_CLASS } from "./field-error"

type InputDatePicker = {
    date?: Date;
    onChange?(value?: Date): void;
    error?: boolean;
}

export const InputDatePicker = (props: InputDatePicker) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={"outline"}
                    className={cn(
                        "w-full justify-start text-left font-normal",
                        props.error && FIELD_ERROR_CLASS,
                        !props.date && "text-muted-foreground"
                    )}
                    >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {props.date ? format(props.date, "dd/MM/yyyy") : <span>Selecione a data</span>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar
                mode="single"
                selected={props.date}
                onSelect={props.onChange}
                initialFocus
                />
            </PopoverContent>
        </Popover>
    )
}